import styled from 'styled-components';

export const ContractContainer = styled.div`
  section {
  }

  main {
    padding: 0 1em 2.5em 1em;
    background: #f6f6f6;
    @media (min-width: 601px) {
      padding: 0 5em 2.75em 5em;
    }
  }
`;
